import { render, staticRenderFns } from "./wizar-crear-lugar-instalacion.vue?vue&type=template&id=c0011c70"
import script from "./wizar-crear-lugar-instalacion.vue?vue&type=script&lang=js"
export * from "./wizar-crear-lugar-instalacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports